/* eslint-disable import/no-cycle */

import Cookies from 'universal-cookie';
import queryString from 'query-string';
import Const from '../const';
import {
  screenNames, routes, wizardScreenPaths, generalPaths, screenPaths
} from '../../components/routes/routes_const';
import { getWebOrderInfoAPI } from '../../../utils/api';
import { setErrorAction, errorTypes } from '../../../redux/application/application_action';
import { routeMatch } from '../../../utils/util';
import { stepLoadedAction } from '../wizard/wizard_actions';

const cookies = new Cookies();
const LAST_SCREEN_COOKIES_KEY = 'wizard_lsn';
const getScreenNameFromCookies = () => cookies.get(LAST_SCREEN_COOKIES_KEY);
const setScreenNameInCookies = (screenName) => cookies.set(LAST_SCREEN_COOKIES_KEY, screenName, { path: '/' });

const getRouteMatch = (matchRoutes) => {
  const match = routeMatch(matchRoutes);
  if (Object.keys(match).length > 0) {
    return match;
  }
  return null;
};

export const canShowScreen = (screenName, pendingWebOrder) => {
  const {
    description, nickname, gender, dateOfBirth, order, advisor, email
  } = pendingWebOrder || {};

  let canShow = false;
  switch (screenName) {
    case screenNames.wizard.whatsNext:
      canShow = !!order;
      break;
    case screenNames.wizard.payment:
      canShow = !!advisor?.id && !!email;
      break;
    case screenNames.wizard.advisorSelection:
      canShow = !!description;
      break;
    case screenNames.wizard.question:
      canShow = !!nickname && !!gender && !!dateOfBirth;
      break;
    case screenNames.wizard.aboutMe:
      canShow = true;
      break;
    default:
      canShow = false;
  }

  return !!canShow;
};

const selectWizardScreenName = (pendingWebOrder) => {
  const {
    description, advisor, email, nickname, gender, dateOfBirth, order, paymentRequired
  } = pendingWebOrder || {};

  let screenName = null;
  switch (true) {
    case !!(order):
      screenName = routes[screenNames.wizard.whatsNext];
      break;
    case !!(advisor && email && paymentRequired):
      screenName = routes[screenNames.wizard.payment];
      break;
    case !!(description):
      screenName = routes[screenNames.wizard.advisorSelection];
      break;
    case !!(nickname && gender && dateOfBirth):
      screenName = routes[screenNames.wizard.question];
      break;
    default:
      screenName = routes[screenNames.wizard.aboutMe];
  }

  return screenName;
};

const getGeneralRoutes = (generalMatch) => {
  const generalPathsKey = Object.keys(generalPaths).find((key) => generalPaths[key] === generalMatch.pattern.path);
  if (generalPathsKey === screenNames.reading) {
    return {
      ...routes[generalPathsKey],
      path: generalMatch.pathname
    };
  }
  return routes[generalPathsKey];
};

const getWizardRoute = () => {
  const wizardRoutes = Object.keys(wizardScreenPaths).map((key) => wizardScreenPaths[key]);
  const wizardMatch = getRouteMatch(wizardRoutes);
  if (wizardMatch !== null) {
    const withardPathsKey = Object.keys(wizardScreenPaths).find((key) => wizardScreenPaths[key] === wizardMatch.pathname);
    const screenRoute = routes[withardPathsKey];
    if (canShowScreen(withardPathsKey)) {
      return screenRoute;
    }
  }
  return null;
};

const selectScreenRoute = (pendingWebOrder) => {
  const generalRoutes = Object.keys(generalPaths).map((key) => generalPaths[key]);
  const generalMatch = getRouteMatch(generalRoutes);
  if (generalMatch !== null) {
    return getGeneralRoutes(generalMatch);
  }

  const initialScreenName = getScreenNameFromCookies();
  if (initialScreenName) {
    const lastRoute = routes[initialScreenName];
    if (lastRoute) {
      return lastRoute;
    }
  }

  const wizardRoute = getWizardRoute();
  if (wizardRoute != null) {
    return wizardRoute;
  }

  return selectWizardScreenName(pendingWebOrder);
};

const initialScreenRoute = (webOrderInfo) => {
  const {
    pendingWebOrder, allowed
  } = webOrderInfo;

  const wizardRoutes = Object.keys(wizardScreenPaths)
    .map((key) => wizardScreenPaths[key]);
  const isWizardMatch = getRouteMatch(wizardRoutes);
  if (isWizardMatch !== null && allowed === false) {
    const queryParams = queryString.stringify(queryString.parse(window.location.search));
    window.location.href = `${ screenPaths.welcome }${ queryParams ? `?${ queryParams }` : '' }`;
    return null;
  }

  const initialScreenName = getScreenNameFromCookies();
  const canShowWelcomeScreen = window.config.showIntroPage === true && !initialScreenName;
  const isWelcomeMatch = getRouteMatch(screenPaths.welcome);
  if (isWelcomeMatch !== null && canShowWelcomeScreen) {
    return routes[screenNames.welcome];
  }

  return selectScreenRoute(pendingWebOrder);
};

export const updateCurrentScreen = (screenName) => (dispatch) => {
  const screen = routes[screenName];
  setScreenNameInCookies(screenName);

  dispatch(stepLoadedAction());

  dispatch({
    type: Const.navigation.updateCurrentScreen,
    currentScreen: screen
  });
};

const updateInitalScreen = (initialScreen) => ({
  type: Const.navigation.initialScreen,
  initialScreen
});

export const setupInitialScreen = () => (dispatch) => {
  getWebOrderInfoAPI().then((webOrderInfo) => {
    const initialScreen = initialScreenRoute(webOrderInfo);
    dispatch(updateInitalScreen(initialScreen));
  }).catch((error) => { dispatch(setErrorAction({ [errorTypes.error]: error })); });
};
